export type ObjectId = string;

export enum Status {
  PENDING = "PENDING",
  DONE = "DONE",
  ERROR = "ERROR",
  ABORTED = "ABORTED",
  IN_PROGRESS = "IN_PROGRESS",
  FINALIZE = "FINALIZE",
}

export interface PostRequest {
  workspace_id: string | null;
}

export type ExportFormat = "csv" | "json" | "xlsx" | "csv_for_excel";
